import { Link } from 'react-router-dom';
import { navLinks, categories } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                糖豆视频
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              糖豆视频，甜蜜每一刻观影时光。汇聚海量高清影视资源，免费在线观看，流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="font-bold text-background-100 mb-4 text-sm">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-background-100 mb-4 text-sm">
              影视分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-background-100 mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@tangdou.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区光华路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024 糖豆视频 TangDou. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-background-400 hover:text-primary-400 transition-colors"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-background-400 hover:text-primary-400 transition-colors"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-background-400 hover:text-primary-400 transition-colors"
              aria-label="B站"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}